import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { WindowProfileUserModel } from 'src/app/models/authentication/window-profile-user.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { InventoryTransferService } from 'src/app/services/inventory/inventory-transfer.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { TransferConstructionSiteService } from 'src/app/services/rental/transfer-construction-site.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {

  private readonly router = inject(Router);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly generalParameterService = inject(GeneralParameterService);
  private readonly inventoryTransferService = inject(InventoryTransferService);
  private readonly transferConstructionSiteService = inject(TransferConstructionSiteService);
  private readonly windowService = inject(WindowService);

  inventoryTransfersInTransit: number = 0;
  swconfirmTransferStore: boolean = false;
  swconfirmTransferConstructionSite: boolean = false;
  transferConstructionSitesInTransit: number = 0;
  windowsByUserAuthenticated: Array<WindowProfileUserModel> = [];

  async ngOnInit() {
    const url = this.router.url as string;
    if (url === '/main') {
      await this.getGeneralParametersByCompany();
      await this.getWindowsByUserAuthenticated();

      if (this.swconfirmTransferStore && this.windowsByUserAuthenticated.some(x => x.windowId === WindowEnums.InventoryTransfer && x.updatable)) {
        await this.howManyInventoryTransfersInTransitByUserAuthenticated();
      }
      if (this.swconfirmTransferConstructionSite && this.windowsByUserAuthenticated.some(x => x.windowId === WindowEnums.TransferConstructionSite && x.updatable)) {
        await this.howManyTransfersContructionSiteInTransitByUserAuthenticated();
      }

      let message = "";
      if (this.inventoryTransfersInTransit > 0) {
        message += `Tiene ${this.inventoryTransfersInTransit} traslado(s) entre bodegas en tránsito. <br>`;
      }
      if (this.transferConstructionSitesInTransit > 0) {
        message += `Tiene ${this.transferConstructionSitesInTransit} traslado(s) entre obras en tránsito. <br>`;
      }
      if (message.length > 0) {
        await this.confirmDialogService.confirm({
          header: 'Traslados en tránsito',
          message: message,
          icon: 'pi pi-info-circle',
          acceptButtonProps: { label: 'Continuar' },
          rejectVisible: false
        });
      }
    }
  }

  async getGeneralParametersByCompany() {
    try {
      const generalParameters = await firstValueFrom(this.generalParameterService.getGeneralParametersByUserAutheticated());
      this.swconfirmTransferStore = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.confirmaTrasladoBodega);
      this.swconfirmTransferConstructionSite = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.confirmaTrasladoObra);
    } catch (error) {
      console.error('Error al buscar las ventanas del usuario autenticado.', error);
    }
  }

  async getWindowsByUserAuthenticated() {
    try {
      this.windowsByUserAuthenticated = await firstValueFrom(this.windowService.getWindowsByUserAuthenticated());
    } catch (error) {
      console.error('Error al buscar las ventanas del usuario autenticado.', error);
    }
  }

  async howManyInventoryTransfersInTransitByUserAuthenticated() {
    try {
      this.inventoryTransfersInTransit = await firstValueFrom(this.inventoryTransferService.howManyTranfersInTransitByUserAuthenticated());
    } catch (error) {
      console.error('Error al buscar la cantidad de traslados en tránsito.', error);
    }
  }

  async howManyTransfersContructionSiteInTransitByUserAuthenticated() {
    try {
      this.transferConstructionSitesInTransit = await firstValueFrom(this.transferConstructionSiteService.howManyTranfersInTransitByUserAuthenticated());
    } catch (error) {
      console.error('Error al buscar la cantidad de traslados en tránsito.', error);
    }
  }
}
